<template>
  <div :class="classes">
    <pt-page-title title="基因报告解读申请" :isSearch="true"></pt-page-title>
    <!-- table -->
    <pt-report-unscramble-apply-table :tableLabels="currentTableLabels">
      <template slot-scope="scope">
        <el-button @click="close(scope.row)" type="text">提交解读</el-button>
        <el-button @click="handleReGet(scope.row)" type="text">驳回申请</el-button>
      </template>
    </pt-report-unscramble-apply-table>
  </div>
</template>

<script>
// 组件class前缀
import { tableLabels } from './report-unscramble-apply-options.js'
import ptReportUnscrambleApplyTable from './pt-report-unscramble-apply-table/withData'
const prefixCls = 'pt-report-unscramble-apply-list'

export default {
  name: 'pt-report-unscramble-apply-list',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptReportUnscrambleApplyTable
  },
  data () {
    return {
      currentTableLabels: tableLabels
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
